// Enviament Estàndard gratis a partir del llindar que calcula el servidor (/shop/free-shipping, 2026-10-12):
// just per sobre del tiquet habitual, perquè el comprador típic hi afegeixi un quadern més.
// El servidor també l'aplica a /create-payment-intent; aquí només es mostra.
import axios from 'axios'

let promise = null
export function loadFreeShipping() {
  if (!promise) {
    promise = axios.get('/shop/free-shipping').then(r => r.data)
    promise.catch(() => { promise = null })
  }
  return promise
}

export function productsTotal(items) {
  return Math.round((items || []).reduce((s, i) => s + i.price * i.quantity, 0) * 100) / 100
}

/** Còpia de les tarifes amb l'Estàndard a 0 € si els productes arriben al llindar */
export async function applyFreeShipping(shippings, items) {
  let rule = null
  try {
    rule = await loadFreeShipping()
  } catch (e) {
    return shippings
  }
  if (!rule || !rule.threshold || productsTotal(items) < rule.threshold) return shippings
  return (shippings || []).map(s => s.title === 'Estàndard' ? {...s, price: 0} : s)
}
